import { getWebchatMessages } from '@/services/webchat-service/webchat.service';
import { useWebchatStore } from '@/store/webchat.store';
import { ReactQueryKeys } from '@/utils/react-query-keys';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

export const useWebchatMessages = (conversationId: number | null) => {
  const setMessages = useWebchatStore((s) => s.setMessages);

  const { data, isPending } = useQuery({
    queryKey: ReactQueryKeys.WEBCHAT_MESSAGES(conversationId!),
    queryFn: () => getWebchatMessages(conversationId!),
    enabled: !!conversationId,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (data && conversationId) {
      setMessages(conversationId, data);
    }
  }, [data, conversationId, setMessages]);

  return { isPending };
};
